import { ABOUTBANNER_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export

export const getAboutBanner = (data) => ({
    type: ABOUTBANNER_GET_LIST,
    payload: data
});
